var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"title"},[_vm._v("测试")]),(_vm.loading)?_c('h2',{staticClass:"subtitle"},[_vm._v("少女祈祷中...")]):[_c('h2',{staticClass:"subtitle"},[_vm._v("Error: "+_vm._s(_vm.errors.length))]),_vm._l((_vm.errors),function(error,n){return _c('p',{key:`error_${n}`,staticClass:"has-text-danger"},[_vm._v(_vm._s(error))])})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }